<div class="workflows-main">
  <div class="workflows-header-main">
    <div class="workflows-header">
      <wm-common-text
        [data]="{
          text: 'Workflows'
        }"
      ></wm-common-text>
    </div>
    <div class="new-workflows-btn">
      <wm-common-button
        [data]="{
          text: 'NEW WORKFLOW',
          type: 'button',
          variant: 'basic',
          disabled: newWorkflowBtnDisable
        }"
        (click)="openNewWorkflowDialog()"
      ></wm-common-button>
    </div>
  </div>

  <mat-tab-group
    class="workflow-tabs"
    mat-stretch-tabs="false"
    mat-align-tabs="start"
    animationDuration="10ms"
    [selectedIndex]="selectedIndex"
    (selectedIndexChange)="onTabChange($event)"
  >
    <mat-tab label="Workflows">
      <div class="tab-content">
        <div class="search-bar">
          <div class="search-input-wrapper">
            <mat-icon class="search-icon">search</mat-icon>
            <input
              class="search-input-wrapper-1"
              type="text"
              placeholder="Search workflows"
              [(ngModel)]="searchText"
              (ngModelChange)="onSearchChange($event)"
            />
          </div>
        </div>

        @if (workflowsLoading()) {

        <wm-common-table
          tableType="Staff"
          [columns]="columns"
          [data]="[]"
          [isLoading]="true"
        >
        </wm-common-table>

        } @else if ((workflows$ | async)?.length > 0) {
        <router-outlet name="appView"></router-outlet>

        <wm-common-table
          *ngIf="!appViewLoading"
          tableType="Staff"
          [columns]="columns"
          [data]="searchText ? filteredWorkflows : (workflows$ | async)"
          [fullHeight]="true"
          tableHeight="calc(100vh - 360px)"
          [showRowsPerPage]="true"
          [showTotalRecords]="true"
          [totalRecords]="
            searchText
              ? filteredWorkflows.length
              : (workflows$ | async)?.length || 0
          "
          [pageSizeStorageKey]="'workflows-janus'"
              [isMobileTabletViewScrollingAndPaginationChanges]="false"

        >
        </wm-common-table>

        <router-outlet name="listWorkflowSettings"></router-outlet>
        <router-outlet name="editWorkflow"></router-outlet>
        <router-outlet name="modal"></router-outlet>

        } @else if (workflowsLoaded) {

        <div class="no-workflows">
          <wm-common-table
            tableType="Staff"
            [columns]="columns"
            [data]="[]"
            [isLoading]="false"
            [fullHeight]="true"
            tableHeight="calc(100vh - 360px)"
          >
          </wm-common-table>
          <router-outlet name="editWorkflow"></router-outlet>
          <router-outlet name="modal"></router-outlet>
        </div>

        }
      </div>
    </mat-tab>
    <mat-tab label="Archive">
      <!-- Start Code added by Sanchit on 06/19/2026 -->
      <!-- //added by Vipul on 04/19/2026 -->
      <div class="search-bar">
        <div class="search-input-wrapper">
          <mat-icon class="search-icon">search</mat-icon>
          <input
            class="search-input-wrapper-1"
            type="text"
            placeholder="Search workflows"
            [(ngModel)]="searchText"
            (ngModelChange)="onSearchChange($event)"
          />
        </div>
      </div>
      <!-- //end by Vipul on 04/19/2026 -->

      @if (archivedLoading()) {

      <wm-common-table
        tableType="Staff"
        [columns]="columns"
        [data]="[]"
        [isLoading]="true"
      >
      </wm-common-table>

      } @else if ((archivedWorkflows$ | async)?.length > 0) {

      <wm-common-table
        tableType="Staff"
        [columns]="columns"
        [data]="searchText ? filteredWorkflows : (archivedWorkflows$ | async)"
        [fullHeight]="true"
        tableHeight="calc(100vh - 360px)"
        [showRowsPerPage]="true"
        [showTotalRecords]="true"
        [totalRecords]="
          searchText
            ? filteredWorkflows.length
            : (archivedWorkflows$ | async)?.length || 0
        "
        [pageSizeStorageKey]="'archived-workflows-janus'"
            [isMobileTabletViewScrollingAndPaginationChanges]="false"


      >
      </wm-common-table>

      <router-outlet name="archiveWorkflowSettings"></router-outlet>
      <router-outlet name="editWorkflow"></router-outlet>
      <router-outlet name="modal"></router-outlet>

      } @else if (archivedLoaded) {

      <div class="no-workflows">
        <wm-common-table
          tableType="Staff"
          [columns]="columns"
          [data]="[]"
          [isLoading]="false"
          [fullHeight]="true"
          tableHeight="calc(100vh - 360px)"
        >
        </wm-common-table>
        <router-outlet name="editWorkflow"></router-outlet>
        <router-outlet name="modal"></router-outlet>
      </div>

      }
    </mat-tab>
    <mat-tab label="Pending">
      <!-- Start Code added by Sanchit on 06/19/2026 -->
      <!-- //added by Vipul on 04/19/2026 -->
      <div class="search-bar">
        <div class="search-input-wrapper">
          <mat-icon class="search-icon">search</mat-icon>
          <input
            class="search-input-wrapper-1"
            type="text"
            placeholder="Search workflows"
            [(ngModel)]="searchText"
            (ngModelChange)="onSearchChange($event)"
          />
        </div>
      </div>
      <!-- //end by Vipul on 04/19/2026 -->

      @if (pendingLoading()) {

      <wm-common-table
        tableType="Staff"
        [columns]="pendingColumns"
        [data]="[]"
        [isLoading]="true"
      >
      </wm-common-table>

      } @else if ((pendingWorkflows$ | async)?.length > 0) {

      <wm-common-table
        tableType="Staff"
        [columns]="pendingColumns"
        [data]="searchText ? filteredWorkflows : (pendingWorkflows$ | async)"
        [fullHeight]="true"
        tableHeight="calc(100vh - 360px)"
        [showRowsPerPage]="true"
        [showTotalRecords]="true"
        [totalRecords]="
          searchText
            ? filteredWorkflows.length
            : (pendingWorkflows$ | async)?.length || 0
        "
        [pageSizeStorageKey]="'pending-workflows-janus'"
            [isMobileTabletViewScrollingAndPaginationChanges]="false"

      >
      </wm-common-table>

      <router-outlet name="editWorkflow"></router-outlet>
      <router-outlet name="modal"></router-outlet>

      } @else if (pendingLoaded) {

      <div class="no-workflows">
        <wm-common-table
          tableType="Staff"
          [columns]="pendingColumns"
          [data]="[]"
          [isLoading]="false"
          [fullHeight]="true"
          tableHeight="calc(100vh - 360px)"
              [isMobileTabletViewScrollingAndPaginationChanges]="false"

        >
        </wm-common-table>

        <router-outlet name="editWorkflow"></router-outlet>
        <router-outlet name="modal"></router-outlet>
      </div>

      }
    </mat-tab>
  </mat-tab-group>
</div>

<div class="modal-width">
  <wm-common-confirmation-modal
    [data]="disableConfirmModal"
    (onYesClick)="onDisableConfirmation()"
    (onNoClick)="disableConfirmModal.open = false"
    (onCloseClick)="disableConfirmModal.open = false"
    [isApplicantMobileview]="true"
  >
  </wm-common-confirmation-modal>
</div>

<div class="modal-width">
  <wm-common-confirmation-modal
    [data]="copyConfirmModal"
    (onYesClick)="onCopyConfirmOk()"
    (onNoClick)="copyConfirmModal.open = false"
    (onCloseClick)="copyConfirmModal.open = false"
    [isApplicantMobileview]="true"
  >
    <ng-container class="copy-textfield">
      <wm-common-textfield
        [data]="{ label: 'New Name' }"
        [(ngModel)]="targetName"
      ></wm-common-textfield>
    </ng-container>
  </wm-common-confirmation-modal>
</div>

<div class="modal-width">
  <wm-common-confirmation-modal
    [data]="copyChoiceModal"
    (onYesClick)="onCopyChoiceYes()"
    (onNoClick)="onCopyChoiceNo()"
    (onCloseClick)="copyChoiceModal.open = false"
    [isApplicantMobileview]="true"
  >
  </wm-common-confirmation-modal>
</div>
<!-- //added by Vipul on 04/19/2026 -->
<div>
  <wm-common-confirmation-modal
    [data]="addJurisdictionModal"
    [isApplicantMobileview]="true"
  >
    <div class="jurisdiction-dropdown">
      <wm-common-dropdown
        [data]="jurisdictionData"
        (change)="onJurisdictionSelected($event)"
      ></wm-common-dropdown>
    </div>

    <div *ngIf="copyWorkflowId && targetClientId1">
      <app-map-workflow
        [sourceWorkflowId]="copyWorkflowId"
        [targetJurisdictionId]="targetClientId1"
        [useTargetJurisdictionInput]="true"
        (finishClicked)="onCopyFinished()"
      ></app-map-workflow>
    </div>
  </wm-common-confirmation-modal>
</div>
<!-- //end by Vipul on 04/19/2026 -->
<div class="modal-width">
  <wm-common-confirmation-modal
    [data]="archiveModalData"
    (onYesClick)="onArchiveConfirmed()"
    (onNoClick)="archiveModalData.open = false"
    [isApplicantMobileview]="true"
  >
    <!-- Start Code added by Sanchit on 06/17/2026 -->
    <!-- <div class="modal-sub-desc">
      <wm-common-text
        [data]="{text: `Are you sure you want to archive this workflow (${archiveWorkflowName})?`}"></wm-common-text>
    </div> -->
    <!-- End Code added by Sanchit on 06/17/2026 -->

    <!-- Reason Field -->
    <ng-container class="reason-textfield">
      <wm-common-textfield
        [data]="{ label: 'Reason' }"
        [(ngModel)]="archiveReason"
      ></wm-common-textfield>
    </ng-container>
    <div class="note">
      <!-- Start Code added by Sanchit on 06/17/2026 -->
      <wm-common-text
        [data]="{ text: 'Things to note:', fontWeight: 'bold' }"
        style="margin-bottom: 20px;"
      ></wm-common-text>
      <!-- End Code added by Sanchit on 06/17/2026 -->
      <wm-common-text
        [data]="{
          text:
            '1. Applications will be no longer be able to be completed for this workflow.'
        }"
      ></wm-common-text>
      <wm-common-text
        [data]="{
          text: '2. This application will not be visible for editing.'
        }"
      ></wm-common-text>
    </div>
  </wm-common-confirmation-modal>
</div>

<div class="modal-width">
  <wm-common-confirmation-modal
    [data]="publishModalData"
    (onYesClick)="onPublishConfirmed()"
    (onNoClick)="publishModalData.open = false"
    [isApplicantMobileview]="true"
  >
    <!-- Reason Field -->
    <div class="note" style="word-break: break-word;">
      <div *ngIf="isValidating" class="text-danger mb-2">
        Validating workflow...
      </div>
      <div *ngIf="!isValidating && hasErrors" class="text-danger mb-2">
        Workflow has errors, please review the errors in the Workflow Builder.
      </div>
      <div
        *ngIf="!isValidating && hasWarnings"
        class="text-warning mb-2"
        style="overflow-wrap: anywhere;"
      >
        Workflow has warnings:
        <ul class="mb-0">
          <li *ngFor="let warning of warningMessages">{{ warning }}</li>
        </ul>
      </div>
      <div
        *ngIf="!isValidating && !hasErrors && !hasWarnings"
        class="text-success mb-2"
      >
        Workflow is valid
      </div>

      <!-- Added ngModelChange to track reason inputs live -->
      <wm-common-textfield
        [data]="{ label: 'Reason', required: 'true' }"
        [(ngModel)]="publishReason"
        (ngModelChange)="onPublishReasonChange()"
      ></wm-common-textfield>

      <wm-common-text
        [data]="{text: `Are you sure you want to publish this workflow (${publishWorkflowName})?`}"
        style="margin-bottom: 20px; margin-top: 2px;"
      ></wm-common-text>
      <!-- Start Code added by Sanchit on 06/17/2026 -->
      <wm-common-text
        [data]="{ text: 'Things to note:', fontWeight: 'bold' }"
        style="margin-bottom: 20px;"
      ></wm-common-text>
      <!-- End Code added by Sanchit on 06/17/2026 -->
      <wm-common-text
        [data]="{
          text:
            '1. All new Applications for this Workflow will use the new configuration.'
        }"
      ></wm-common-text>
      <wm-common-text
        [data]="{
          text:
            '2. Existing Applications already in progress will continue to use the old configuration.'
        }"
      ></wm-common-text>
      <wm-common-text
        [data]="{
          text:
            '3. Any renewable workflows that use this workflow as its renewal will also be published.'
        }"
      ></wm-common-text>
      <wm-common-text
        [data]="{
          text:
            '4. Any workflow that is a renewal of this workflow will also be published.'
        }"
      ></wm-common-text>
    </div>
  </wm-common-confirmation-modal>
</div>

<div class="history-modal">
  <wm-common-confirmation-modal
    [data]="workflowCheckpointsModal"
    (onCloseClick)="workflowCheckpointsModal.open = false"
    [isApplicantMobileview]="true"
  >
    <div class="history-group" *ngIf="checkpoints && checkpoints.length > 0">
      <div
        *ngIf="checkpoints && checkpoints.length > 0"
        class="cleanup-history-btn"
      >
        <wm-common-button [data]="openCleanupHistoryModal()"></wm-common-button>
      </div>
      <div *ngFor="let cp of checkpoints" class="history-item-grp">
        <div class="restore-btn-container">
          <button
            class="restore-btn"
            [disabled]="isRestoring(cp.id)"
            (click)="restoreVersion(cp.id)"
          >
            <span *ngIf="!isRestoring(cp.id)">RESTORE</span>

            <span *ngIf="isRestoring(cp.id)">
              <span
                class="spinner-border spinner-border-sm"
                role="status"
                aria-hidden="true"
              ></span>
              RESTORING...
            </span>
          </button>
        </div>
        <div class="history-item">
          <div class="common-text-bold">
            <wm-common-text
              [data]="{
                text: cp.notes
              }"
            ></wm-common-text>
          </div>
          <div>
            <wm-common-text
              [data]="{
                text: cp.createdOnString
              }"
            ></wm-common-text>
          </div>
          <div>
            <wm-common-text
              [data]="{
                text: cp.createdBy
              }"
            ></wm-common-text>
          </div>
        </div>
      </div>
    </div>
  </wm-common-confirmation-modal>
</div>

<div class="modal-width">
  <wm-common-confirmation-modal
    *ngIf="checkpoints && checkpoints.length > 0 && selectedWorkflow"
    [data]="cleanupHistoryModalData"
    (onYesClick)="confirmCleanupHistory()"
    (onNoClick)="cleanupHistoryModalData.open = false"
    [isApplicantMobileview]="true"
  >
    <p>
      Cleaning up the history of this workflow will have the following effects:
    </p>
    <ul>
      <li>You will not be able to restore removed checkpoints.</li>
    </ul>
  </wm-common-confirmation-modal>
</div>

<div class="modal-width">
  <wm-common-confirmation-modal
    [data]="deleteConfirmModal"
    (onYesClick)="deletePending()"
    (onNoClick)="deleteConfirmModal.open = false"
    (onCloseClick)="deleteConfirmModal.open = false"
    [isApplicantMobileview]="true"
  >
  </wm-common-confirmation-modal>
</div>
